import { APP_VERSION, APP_VERSION_KEY } from '../config/version';
import UserProfile from '../components/Common/UserProfile';

/** Verifica se a versão da aplicação mudou.
 * Sempre atualiza a versão no localStorage. Se a major version mudou, limpa o cache.
 * @returns true se a versão major mudou; false caso contrário.
 */
export const checkAppVersion = () => {
  try {
    const storedVersion = localStorage.getItem(APP_VERSION_KEY);

    if (!storedVersion) {
      localStorage.setItem(APP_VERSION_KEY, APP_VERSION);
      return false;
    }

    if (storedVersion !== APP_VERSION) {
      UserProfile.clear();

      return true;
    }

    return false;
  } catch (error) {
    console.log('Erro ao verificar versão da aplicação:', error);
    return false;
  }
};

/** Salva a versão atual no localStorage após login bem-sucedido. */
export const saveAppVersion = () => {
  try {
    localStorage.setItem(APP_VERSION_KEY, APP_VERSION);
  } catch (error) {
    console.log('Erro ao salvar versão da aplicação:', error);
  }
};
